import { render } from "./Masthead.vue?vue&type=template&id=1610f9df"
import script from "./Masthead.vue?vue&type=script&lang=js"
export * from "./Masthead.vue?vue&type=script&lang=js"

import "./Masthead.vue?vue&type=style&index=0&id=1610f9df&lang=scss"

import exportComponent from "/Users/pamelamontanez/Documents/projects/personal-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__